import { inject, injectable } from 'inversify'
import symbols from '../../symbols'
import {
  FetchOfferUseCaseInput,
  FetchOfferUseCaseOutput,
  IAppErrorFactory,
  IFetchOfferUseCase,
  IOffersService,
} from '../../types'

@injectable()
export default class FetchOfferInteractor implements IFetchOfferUseCase {
  @inject(symbols.IOffersService) private offersService: IOffersService

  @inject(symbols.IAppErrorFactory) private errorFactory: IAppErrorFactory

  async handle(input: FetchOfferUseCaseInput): Promise<FetchOfferUseCaseOutput> {
    const output = this.getDefaultOutputData()
    try {
      const offer = await this.offersService.fetchOffer(input)

      output.offer = offer
    } catch (e) {
      output.error = this.errorFactory.create({
        originalInstance: e as Error,
      })
    }

    return output
  }

  private getDefaultOutputData(): FetchOfferUseCaseOutput {
    return {
      offer: null,
      error: null,
    }
  }
}
